import { render, staticRenderFns } from "./AllBadges.vue?vue&type=template&id=6959dc54&scoped=true"
import script from "./AllBadges.vue?vue&type=script&lang=js"
export * from "./AllBadges.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6959dc54",
  null
  
)

export default component.exports